<template>
	<div class="drawer">
		<el-drawer
		size="400px"
		title="我是标题"
		:visible.sync="drawerStatus"
		:with-header="false"
		@close='handleClose'
		>
			<img src="../../../../assets/img/remark.png" class="avatar" style="width:200px;"/>
			<el-form :inline="true" class="form">
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="24">
							<el-form-item label="挂单备注:" :label-width="formLabelWidth">
								<el-input v-model="remarkGuahao" type="textarea" :rows="5" style="width:280px;" placeholder="请录入挂单备注"></el-input>
							</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div style="height: 40px;width:100%;"></div>
			<div class="btnBox">
				<div class="btnItem" @click="handleClose">取消</div>
				<div class="btnItem submit" @click="submitCode">确定</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				formLabelWidth:'80px',
				remarkGuahao:'',
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			curPetId(){
				return this.$store.state.mendian.curPetId;
			},
			curPetInfo(){
				return this.$store.getters['mendian/curPetInfo'];
			},
			saleList(){
				return this.$store.state.mendian.saleList;
			},
			remark(){
				return this.$store.state.mendian.remark;
			},
			remarkGuahao1(){
				return this.$store.state.mendian.remarkGuahao;
			},
			jiedanItem(){
				return this.$store.state.mendian.jiedanItem;
			},
			saleTotal(){
				if(this.$store.state.mendian.saleTotal){
					return this.$store.state.mendian.saleTotal;
				}else{
					return {
						total:0,
						activity:0,
					}
				}
			},
			curDiscountCard(){
				return this.$store.state.mendian.curDiscountCard;
			},
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
			})
			this.remarkGuahao = this.remarkGuahao1;
		},
		methods: {
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
			submitCode(){
				let arr = []
				for(let i=0;i<this.saleList.length;i++){
					let item = JSON.parse(JSON.stringify(this.saleList[i]))
					item.activityList = []
					arr.push(item)
				}
				let params = {
					"memberId": this.userInfo._id,
					"memberName": this.userInfo.basic_info.nick_name,
					"petId": this.curPetInfo._id,
					"petName": this.curPetInfo.nick_name,
					"petType": this.curPetInfo.type_name,
					"totalMoney": this.saleTotal.activity,
					"remark": this.remarkGuahao+'_explain_'+this.remark,
					"orderContent": JSON.stringify(arr),
					"couponContent":JSON.stringify(this.curDiscountCard||''),
				}
				let loading = this.$loading()
				this.$http.post('/api/HandOrder/Insert', params).then(r => {
					loading.close()
					if (r.code == 0) {
						this.$message({
							message: '挂单成功',
							type: 'success'
						});
						if(this.jiedanItem&&this.jiedanItem.recordId){
							this.delGuadan()
						}
						this.$emit('submit',{type:'success'})
					}
				})
			},
			delGuadan(){
				let params = {
					"hangOrderId": this.jiedanItem.recordId,
				}
				this.$http.delete('/api/HandOrder/Delete', params).then(res => {
					console.log('删除挂单',res)
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.avatar{
				width:300px;
				display: block;
				margin:150px auto 80px;
			}
			.form{
				::v-deep .el-form-item{
					margin:5px 0;
				}
			}
		}
		
	}
	.btnBox{
		width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
		.btnItem{
			text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
			&.submit{
				background-color: $mainColor;
			}
		}
	}
</style>
